import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import Select from 'react-select'
import { newAdminSchema } from '../../../util/validationSchema'
import { yupResolver } from '@hookform/resolvers/yup'

const NewAdmin = ({ toggle }) => {
  const { allAdmin } = useSelector(({ adminControl }) => adminControl)
  const { allRegion } = useSelector(({ region }) => region)

  const {
    handleSubmit,
    control,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(newAdminSchema),
    defaultValues: {}
  })

  const onSubmit = (data) => {
    console.log('data :>> ', data)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div className="col-lg-12 col-sm-12">
          <div className="form-group input_text">
            <label>
              Admin
              <span className="text-danger"> *</span>
            </label>
            <Controller
              name="admin_id"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  className={`react-selectcomponent form-control ${errors?.admin_id ? 'error-input' : ''}`}
                  getOptionLabel={(option) => `${option.first_name}`}
                  getOptionValue={(option) => `${option.admin_id}`}
                  options={allAdmin?.admins || []}
                  isSearchable={true}
                  isClearable
                  placeholder={`Select Admin`}
                  classNamePrefix="select_kanakku"
                />
              )}
            />
            <small>{errors?.admin_id?.admin_id?.message}</small>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-sm-12">
          <div className="form-group input_text">
            <label>Region</label>
            <Controller
              name="region"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  className={`react-selectcomponent form-control select-box-filed`}
                  getOptionLabel={(option) => `${option.region}`}
                  getOptionValue={(option) => `${option.region_id}`}
                  options={allRegion || []}
                  isClearable
                  isSearchable={true}
                  placeholder={`Select Region`}
                  classNamePrefix="select_kanakku"
                  defaultValue={''}
                />
              )}
            />
            <small>{errors?.region?.region_id?.message}</small>
          </div>
        </div>
      </div>
      <div className="multi_btn_div">
        <button type="button" className="btn common-outline-btn w-100" onClick={() => toggle()}>
          Cancel
        </button>
        <button type="submit" className="btn btn-primary common-field-btn w-100">
          {`Save`}
        </button>
      </div>
    </form>
  )
}

export default NewAdmin
